/**
 * Canonical profile taxonomy (categories, services) for Grey Dates.
 * Used by browse filters, profile creation/editing, and backend validation.
 * Keep backend/src/data/profileTaxonomy.js in sync.
 */

export const PROFILE_GENDER_CATEGORIES = [
  "Female",
  "Male",
  "Trans",
];

export const PROFILE_ROLE_CATEGORIES = [
  "Couple",
  "MILF",
  "Gay",
  "Escort",
  "Massage",
  "BDSM",
  "Webcam",
  "Party / Swinger",
];

export const PROFILE_CATEGORIES = [
  ...PROFILE_GENDER_CATEGORIES,
  ...PROFILE_ROLE_CATEGORIES,
];

export const SERVICE_SECTIONS = [
  {
    id: "angebot",
    title: "Angebot",
    items: [
      "Girlfriend Experience",
      "Oral",
      "Anal",
      "Outdoor",
      "Overnight",
      "Duo / Threesome",
      "Kissing",
      "Striptease",
      "Roleplay",
      "Party",
      "Verified",
      "New",
      "Premium",
    ],
  },
  {
    id: "bdsm",
    title: "Domina / BDSM Sex Angebote",
    items: [
      "Domination",
      "Submission",
      "Bondage",
      "Fetish",
      "Foot Fetish",
      "Spanking",
      "Latex / Leather",
      "Strap-on",
      "Humiliation",
      "CBT / Sensation",
    ],
  },
  {
    id: "massage",
    title: "Massage Angebote",
    items: [
      "Erotic Massage",
      "Body-to-Body",
      "Tantra",
      "Thai Massage",
      "Nuru",
      "Prostate Massage",
      "Couples Massage",
      "Sensual Oil Massage",
    ],
  },
];

/** All service accordion sections open in the filter sheet. */
export const DEFAULT_EXPANDED_SERVICE_SECTIONS = { angebot: true, bdsm: true, massage: true };

export const SERVICE_OPTIONS = SERVICE_SECTIONS.flatMap((section) => section.items);

/** Who the profile offers services to — matches mockProfiles `serviceFor`. */
export const SERVICE_FOR_OPTIONS = ["Men", "Women", "Couples"];

/** Languages shown on profile cards/details — matches mockProfiles `languages[].name`. */
export const SPOKEN_LANGUAGE_OPTIONS = [
  "English",
  "German",
  "French",
  "Spanish",
  "Italian",
  "Portuguese",
];

export function isValidServiceFor(option) {
  return SERVICE_FOR_OPTIONS.includes(option);
}

export function isValidSpokenLanguage(language) {
  return SPOKEN_LANGUAGE_OPTIONS.includes(language);
}

export function isValidCategory(category) {
  return PROFILE_CATEGORIES.includes(category);
}

export function isValidService(service) {
  return SERVICE_OPTIONS.includes(service);
}

export function areValidCategories(categories = []) {
  return Array.isArray(categories) && categories.every(isValidCategory);
}

export function areValidServices(services = []) {
  return Array.isArray(services) && services.every(isValidService);
}

export function isProfileGenderCategory(category) {
  return PROFILE_GENDER_CATEGORIES.includes(category);
}

export function hasProfileGender(profileTypes = []) {
  return profileTypes.some(isProfileGenderCategory);
}

/** Keep at most one gender tag; preserve role tags. */
export function normalizeProfileTypes(profileTypes = []) {
  const list = Array.isArray(profileTypes) ? profileTypes : [];
  const roles = list.filter((item) => PROFILE_ROLE_CATEGORIES.includes(item));
  const gender = list.find((item) => PROFILE_GENDER_CATEGORIES.includes(item)) ?? null;
  return gender ? [gender, ...roles] : roles;
}

/** Pick one gender tag; other gender tags are removed. Role tags stay as-is. */
export function selectProfileGender(profileTypes = [], genderCategory) {
  if (!isProfileGenderCategory(genderCategory)) {
    return normalizeProfileTypes(profileTypes);
  }

  const roles = profileTypes.filter((item) => PROFILE_ROLE_CATEGORIES.includes(item));
  if (profileTypes.includes(genderCategory)) {
    return roles;
  }

  return [genderCategory, ...roles];
}

export function toggleProfileRoleCategory(profileTypes = [], roleCategory) {
  if (!PROFILE_ROLE_CATEGORIES.includes(roleCategory)) {
    return normalizeProfileTypes(profileTypes);
  }

  const gender = profileTypes.find((item) => PROFILE_GENDER_CATEGORIES.includes(item)) ?? null;
  const roles = profileTypes.filter((item) => PROFILE_ROLE_CATEGORIES.includes(item));
  const nextRoles = roles.includes(roleCategory)
    ? roles.filter((item) => item !== roleCategory)
    : [...roles, roleCategory];

  return gender ? [gender, ...nextRoles] : nextRoles;
}
